/** Automations (list and editor), Integrations and the integration cards. */
export const automations = {
  /* shared marks and run status */
  statusRunning: 'running',
  statusOk: 'ok',
  statusFailed: 'failed',
  connected: 'connected',
  notConnected: 'not connected',
  disconnect: 'Disconnect',
  connect: 'Connect',
  reconnect: 'Reconnect',
  runTime: '{day} · {time}',

  /* schedules */
  scheduleDaily: 'Every day',
  scheduleWeekdays: 'Weekdays',
  scheduleWeekly0: 'Every Sunday',
  scheduleWeekly1: 'Every Monday',
  scheduleWeekly2: 'Every Tuesday',
  scheduleWeekly3: 'Every Wednesday',
  scheduleWeekly4: 'Every Thursday',
  scheduleWeekly5: 'Every Friday',
  scheduleWeekly6: 'Every Saturday',
  scheduleWhenTime: '{when} {time}',

  /* why an automation cannot run yet */
  incompleteApprovalCanvas: 'Pick a canvas to watch for approvals',
  incompleteAddStep: 'Add a step',
  incompleteStepCanvas: 'Pick a canvas for every step',
  incompleteMetaAccount: 'Pick a Meta ad account',
  incompleteAgentPrompt: 'Write what the agent should do',
  incompleteSlackChannel: 'Enter a Slack channel ID',
  incompleteSlackMessage: 'Write a Slack message',
  incompleteLinearTeam: 'Choose a Linear team',
  incompleteLinearTitle: 'Write a Linear ticket title',

  /* the example automations: what the cards and tiles say */
  exampleApprovedSizesName: 'Make different sizes',
  exampleApprovedSizesBlurb: 'Adapt approved designs into square, portrait and landscape drafts.',
  exampleApprovedLocalizationName: 'Localize approved designs',
  exampleApprovedLocalizationBlurb: 'Translate approved designs and adapt their layouts.',
  exampleApprovedAssetsName: 'Create companion assets',
  exampleApprovedAssetsBlurb: 'Turn an approved direction into a campaign set.',
  exampleWeeklyCreativesName: 'Weekly ad creatives',
  exampleWeeklyCreativesBlurb: 'Pull every active Meta ad onto a canvas each Monday.',
  exampleAdVariantsName: 'Ad variants',
  exampleAdVariantsBlurb: 'Pull this week’s creatives, then have Doop spin up five variants of each.',
  exampleFridayUxName: 'Friday UX review',
  exampleFridayUxBlurb: 'The UX Lead reviews everything that changed this week.',
  exampleBrandA11yName: 'Brand and accessibility check',
  exampleBrandA11yBlurb: 'Bring every frame back on brand and up to WCAG AA.',
  exampleCopyPassName: 'Weekly copy pass',
  exampleCopyPassBlurb: 'The Copywriter tightens every headline and label.',
  exampleNightlyPolishName: 'Nightly polish',
  exampleNightlyPolishBlurb: 'Visual Polish tidies spacing and alignment every evening.',

  /* agent roles' one-liners */
  roleBlurbDoop: 'Generalist designer — makes the thing',
  roleBlurbUx: 'Flow, hierarchy, states, affordances',
  roleBlurbCopy: 'Headlines, microcopy, labels, CTAs',
  roleBlurbBrand: 'Palette, type, logo, tone of voice',
  roleBlurbA11y: 'Contrast, semantics, focus, target size',
  roleBlurbPolish: 'Spacing rhythm, alignment, final detail',

  /* the Automations list */
  newAutomation: 'New automation',
  newAutomationPlus: '+ New automation',
  createFailed: 'Couldn’t create the automation',
  saveFailed: 'Couldn’t save',
  deleteFailed: 'Couldn’t delete',
  emptyTitle: 'Nothing runs on its own yet',
  emptyDescription:
    'Run on a schedule or when designs are approved. Create variants, hand off tickets and share updates.',
  columnAutomation: 'Automation',
  columnCanvas: 'Canvas',
  columnLastRun: 'Last run',
  columnNextRun: 'Next run',
  toggleNamed: '{name} on or off',
  canvasFallback: 'Canvas',
  pickCanvas: 'Pick a canvas',
  running: 'Running',
  failed: 'Failed',
  fix: 'Fix',
  never: 'Never',
  paused: 'paused',
  onApproval: 'on approval',
  finishSetup: 'finish setup',
  actionsFor: 'Actions for {name}',
  deleteTitle: 'Delete “{name}”?',
  automationFallback: 'automation',
  deleteDescription:
    'It stops running and its run history goes with it. Frames it already created stay on their canvases.',
  whenApprovedLower: 'when designs are approved',
  startFromExample: 'Start from an example',
  whenApproved: 'When designs are approved',
  use: 'Use',

  /* the editor */
  untitledAutomation: 'Untitled automation',
  on: 'On',
  off: 'Off',
  automationToggle: 'Automation on or off',
  reasonFirst: '{reason} first',
  runNowTitle: 'Run the automation now',
  runningEllipsis: 'Running…',
  runNow: 'Run now',
  saving: 'Saving…',
  renameFailed: 'Couldn’t rename',
  runFailed: 'Couldn’t run',
  missing: 'That automation doesn’t exist any more.',
  backToAutomations: 'Back to automations',
  addStep: '+ Add step',
  reasonToTurnOn: '{reason} to turn it on.',
  orStartFromExample: 'Or start from an example',
  daily: 'daily',
  weekdays: 'weekdays',
  runs: 'Runs',
  runsLast: 'Runs · last {time}',
  when: 'When',
  triggerLabel: 'Automation trigger',
  triggerSchedule: 'On a schedule',
  triggerApproval: 'Designs are approved',
  approvalHint:
    'Runs when frames are marked ready for dev. Nearby approvals are grouped; generated designs stay drafts.',
  every: 'Every',
  dayOption0: 'Sunday',
  dayOption1: 'Monday',
  dayOption2: 'Tuesday',
  dayOption3: 'Wednesday',
  dayOption4: 'Thursday',
  dayOption5: 'Friday',
  dayOption6: 'Saturday',
  dayOptionWeekdays: 'weekday',
  dayOptionDaily: 'day',
  at: 'at',
  whichDays: 'Which days',
  time: 'Time',
  canvasOn: 'on',
  canvasInto: 'into',
  canvasFor: 'for',
  chooseCanvas: 'Choose a canvas',
  noCanvases: 'No canvases yet',
  loadTeamsFailed: 'Could not load teams. Check your Linear connection.',
  postToSlack: 'Post to Slack',
  createLinearTicket: 'Create Linear ticket',
  connectProvider: 'Connect {name}',
  slackChannelLabel: 'Slack channel ID',
  slackChannelPlaceholder: 'Channel ID, e.g. C012ABCDEF',
  slackChannelHint: 'Copy the ID from Slack channel details and invite @Doop to the channel.',
  slackMessageLabel: 'Slack message',
  linearTeamLabel: 'Linear team',
  chooseTeam: 'Choose a team',
  ticketTitleLabel: 'Linear ticket title',
  ticketTitlePlaceholder: 'Ticket title',
  ticketDescriptionLabel: 'Linear ticket description',
  ticketDescriptionPlaceholder: 'What needs to happen next?',
  deliveryHint: 'Includes design links and results. Waits for earlier design tasks to finish.',
  removeStep: 'Remove step',
  pullMeta: 'Pull · Meta Ads',
  adCreatives: 'Ad creatives',
  notConnectedYet: 'Not connected yet',
  connectMeta: 'Connect Meta',
  adAccount: 'Ad account',
  whichAds: 'Which ads',
  activeAds: 'Active ads',
  allAds: 'All ads',
  agentTask: 'Agent task',
  taskTitle: 'Task title',
  untitledTask: 'Untitled task',
  agentPromptPlaceholder: 'What should the agent do on this canvas?',
  picksUp: '{role} picks it up right away',
  whatShouldRun: 'What should run?',
  shareResults: 'Share design links and results from earlier steps.',
  metaPullBlurb: 'Pull Meta ad creatives onto a canvas.',
  agentTaskBlurb: 'Give Doop, UX Lead or another role a brief on a canvas.',
  collapsePanel: 'Collapse panel',
  nextRun: 'Next run',
  pausedTitle: 'Paused',
  saveToSee: 'Save to see when it runs next.',
  waitingApprovals: 'Waiting for new design approvals.',
  notScheduled: 'Not scheduled.',
  noRunsYet: 'No runs yet.',
  noRunsApproval: 'Approve designs on the selected canvas to start.',
  noRunsScheduled: 'The first one is on the schedule.',
  noRunsFinish: 'Finish the setup and turn it on, or run it now.',
  nothingNew: 'Nothing new',
  reconnectMeta: 'Reconnect Meta',
  openCanvas: 'Open {name}',
  canvasLower: 'canvas',
  showOlder: 'Show older',
  durationSeconds: '{s}s',
  durationMinutes: '{m}m {s}s',

  /* the Integrations page */
  providerConnected: '{name} connected.',
  metaStartFailed: 'Couldn’t start the Meta connection',
  disconnectFailed: 'Couldn’t disconnect',
  metaAccounts: { one: '{name} · {count} ad account', other: '{name} · {count} ad accounts' },
  metaPitch: 'Pull ad creatives onto a canvas',
  usedBy: { one: 'Used by {count} automation', other: 'Used by {count} automations' },
  notUsedYet: 'Not used by an automation yet',
  metaDisconnectCopy:
    'Automations that pull from Meta will fail until you connect again. Frames already on your canvases stay.',
  metaExpiresSoon: 'Meta’s access expires soon — reconnect to keep pulls running.',
  metaNotConfigured: 'Not configured on this server — set META_APP_ID and META_APP_SECRET.',
  disconnectTitle: 'Disconnect {name}?',

  /* Linear */
  installFailed: 'Could not install Doop.',
  linearConnectFailed: 'Could not connect Linear.',
  linearKeyReplaced: 'Linear key replaced.',
  linearConnected: 'Linear connected.',
  doopAgentIn: 'Doop agent · {workspace}',
  linearAccount: 'Linear account',
  linearPitch: 'Delegate tickets to the Doop design agent',
  automaticPickup: 'Automatic design pickup',
  readOnlyAccess: 'Read-only ticket access',
  manage: 'Manage',
  manageLinear: 'Manage Linear',
  connectLinear: 'Connect Linear',
  linearLede: 'Choose how Doop works with your Linear workspace.',
  linearDelegate: 'Delegate an issue to Doop in Linear. The design and canvas link arrive automatically.',
  linearInstallBody:
    'Install Doop in a Linear workspace you administer. Delegated tickets create private canvases in your Doop account and run on your connected model account or task allowance. Workspace members who can delegate to Doop can start these runs.',
  installAgent: 'Install Doop agent',
  linearNeedsApp: 'Automatic design pickup needs a Linear app configured by this server’s administrator.',
  replaceKey: 'Replace key',
  linearKeyBefore: 'Create a personal API key in Linear under',
  linearKeyLink: 'Settings → Security & access',
  linearKeyAfter: 'with read access to the teams you want agents to see. The key is stored on the server.',
  linearKeyLabel: 'Linear personal API key',
  checking: 'Checking…',
  saveKey: 'Save key',
  linearKeyStays: 'Your current key stays connected until the replacement is verified.',
  linearDisconnectCopy:
    'Stop automatic pickup and pending Linear design work, and remove ticket access. Existing canvases stay. To remove the Doop agent from Linear too, uninstall the app in Linear Settings.',

  /* Slack */
  slackWorkspace: 'Slack workspace',
  slackPitch: 'Mention @Doop with a design brief',
  slackFootnote: 'Anyone in the workspace can mention @Doop; every run spends your model account or task allowance',
  slackNeedsApp: 'Needs a Slack app configured by this server’s administrator',
  installSlack: 'Install Doop in Slack',
  slackDisconnectCopy:
    'Stop @Doop mentions and pending Slack design work in this workspace. Existing canvases stay. To remove Doop from Slack too, uninstall the app in Slack’s workspace settings.',
} as const
